import SentMessage from "./SentMessage";

export default SentMessage;
